import { AppService } from "app/services/app.service";

import { Conta } from "app/pages/full-pages/conta/conta.model";
import { Observable } from "rxjs";

export abstract class AbConta extends AppService {
  abstract KEY_MULTICONTA: string;
  abstract getConta();
  abstract saveConta(conta: Conta): Observable<any>;
  abstract salvarTipoConta(conta: Conta): Observable<any>
  abstract getTipoContaLogada();
  abstract eMulticonta();
  abstract salvarEMultiContaNoStorage(mlt: Observable<any>);
  abstract cleanToken();
  abstract getMultiContaStorage(): boolean;
} 